import {UserService} from '@nuskin/ns-account';
import {ConfigService} from '@nuskin/ns-util';
import axios from 'axios';


const headers = {
    client_id: '3eee8207a8224d4bbc1c667438269591',
    'Content-Type': 'application/json'
}

const AssessmentService = function() {
    // ==================================
    // PUBLIC FUNCTIONS
    // ==================================

    return {
        getAssessmentsV2
    };

    async function getAssessmentsV2(success, failure) {
        const URL = `${ConfigService.getMarketConfig(false, undefined, true).awsUrl}/ns-share-api/v1/connect/user/`;
        const res = {
            assessments: []
        };
        const user = UserService.getUser();
        if (!user) {
            failure({ noAssessments: true });
            return;
        }

        if (user.id) {
            try {
                const { data: assessments } = await axios.get(`${URL}${user.id}/agelocme`, { headers });
                const { agelocmeData } = assessments;
                if (agelocmeData) {
                    Object.keys(agelocmeData).forEach(key => {
                        agelocmeData[key].id = key;
                        res.assessments.push(agelocmeData[key]);
                    });
                }
                console.log(assessments);
                success(res);
            } catch (err) {
                failure({
                    noAssessments: true
                })
            }
        }
    }
}();

export default AssessmentService;
